import { Injectable, WritableSignal, signal, inject } from '@angular/core'
import { AuthService } from '@auth0/auth0-angular'
import { EnvironmentService } from './environment.service'
import { IAsset } from '../interfaces/asset.interface'

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  private authService = inject(AuthService)
  private environmentService = inject(EnvironmentService)

  initialized = false
  isAuthenticated = false
  adminHidden = signal(false)
  mobilePreviewMode = signal(false)
  mobilePreviewWidth = signal(375)
  loadedAsset: WritableSignal<IAsset | undefined> = signal(undefined)

  init(): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        if (this.environmentService.get().useMock && this.environmentService.get().useMockAdmin) {
          this.setup(true)
          resolve()
        }
        if (this.initialized) {
          return
        }

        this.authService.isAuthenticated$.subscribe(
          (auth) => {
            this.setup(auth)
            resolve()
          }
        )
      } catch (error) {
        reject(error)
      }
    })
  }

  setup(auth: boolean): void {
    this.initialized = true
    this.isAuthenticated = auth
  }

  disableAdmin(): void {
    this.isAuthenticated = false
  }

  isAdminEnabled(): boolean {
    return this.isAuthenticated
  }

  toggleAdminHidden() {
    this.adminHidden.set(!this.adminHidden())
  }

  toggleMobilePreviewMode() {
    this.mobilePreviewMode.set(!this.mobilePreviewMode())
  }
}
